export const selectPromoIsUsed = (state) => state.promoReducer.isUsed;
